module.exports = __webpack_public_path__ + "static/media/ue_resized.f1b884f1.png";